import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import unavailableHeavyProducts from '~/const/patch';
var COLORS = {
  IN_STOCK: 'green',
  UNAVAILABLE: 'red',
  SOON: 'orange',
  MONTH: 'orange',
  WEEK: 'orange',
  LIMITED: 'orange',
  STORE_ONLY: 'black',
  DELETE: 'white',
  default: 'black'
};
export default {
  name: 'ProductStock',
  props: {
    stock: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showOnlyInStock: {
      type: Boolean,
      default: false
    },
    reference: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentStock: function currentStock() {
      if (this.stock.status === 'STORE_ONLY' && unavailableHeavyProducts(this.reference, this.locale.iso)) {
        return this.$t('unavailable');
      }

      return this.stock.message || this.$t('IN_STOCK');
    },
    color: function color() {
      return COLORS[this.stock.status] || COLORS.default;
    }
  })
};